import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

const BRAND = process.env.REACT_APP_BACKEND_URL;

export default function Auth() {
  const { login, user } = useAuth();
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const mode = "login";
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) navigate("/mi-archivo"); }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(form.email, form.password);
      toast.success("Bienvenida al archivo");
      navigate("/mi-archivo");
    } catch (err) {
      toast.error(errMsg(err));
      setBusy(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/mi-archivo";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={`${BRAND}/brand/img2.jpeg`} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
        <div className="absolute bottom-12 left-10">
          <p className="font-script text-4xl text-[#F4F4F3]">Construí tu propio archivo.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 lg:p-16">
        <div className="w-full max-w-sm">
          <Logo size="text-2xl" />
          <h1 className="font-display font-extrabold uppercase tracking-tight text-3xl text-[#171719] mt-8">
            Ingresá
          </h1>
          <p className="text-sm text-[#565A61] mt-2">Accedé a tus piezas, códigos y a la sección Camila Guerra.</p>

          <form onSubmit={submit} className="mt-8 flex flex-col gap-4">
            <div>
              <Label className="dossier-label text-[#565A61]">Email</Label>
              <Input data-testid="auth-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2 bg-[#F4F4F3] border-[#C4C7CD] text-[#171719]" />
            </div>
            <div>
              <Label className="dossier-label text-[#565A61]">Contraseña</Label>
              <Input data-testid="auth-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-2 bg-[#F4F4F3] border-[#C4C7CD] text-[#171719]" />
            </div>
            <button data-testid="auth-submit" disabled={busy} className="btn-ink py-4 dossier-label mt-2 disabled:opacity-60">
              {busy ? "Procesando…" : "Ingresar"}
            </button>
          </form>

          <div className="flex items-center gap-3 my-5">
            <div className="h-px flex-1 bg-[#CFD1D6]" />
            <span className="dossier-label text-[#565A61]">o</span>
            <div className="h-px flex-1 bg-[#CFD1D6]" />
          </div>
          <button data-testid="google-login" onClick={google} className="btn-outline-ink w-full py-3.5 dossier-label">Continuar con Google</button>

          <p className="text-sm text-[#565A61] mt-6 text-center">
            <span data-testid="auth-buyer-note" className="text-xs text-[#565A61] leading-relaxed block">
              Las cuentas son solo para clientas: se crean solas con tu primera compra, desde el email de agradecimiento.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
